/** Ressources de traduction statiques ; les clés restent vérifiées par TypeScript. */
import textes from './traductions/distribution-publics.json' with { type: 'json' };
export const TEXTES_DISTRIBUTION_PUBLICS = textes;
//# sourceMappingURL=textes-distribution-publics.js.map